import { motion } from 'framer-motion';
import { useState } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/SEOHead';

export default function DienstenSmartphonePage() {
  const [activeService, setActiveService] = useState(0);
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://dsfcartech.be';

  const services = [
    {
      id: 'carplay',
      icon: 'ri-smartphone-line',
      title: 'CarPlay & Android Auto',
      subtitle: 'Naadloze smartphone integratie',
      description: 'Upgrade uw auto met draadloze CarPlay en Android Auto in Antwerpen. Geniet van naadloze smartphone integratie met uw dashboard voor navigatie, muziek, berichten en meer.',
      longDescription: 'Bij DSF Cartech in Antwerpen installeren wij professionele CarPlay en Android Auto systemen in vrijwel elk automerk. Of u nu een oudere auto heeft zonder moderne technologie, of een nieuwer model wilt upgraden naar draadloze connectiviteit - wij hebben de oplossing. Onze CarPlay installatie Antwerpen service is beschikbaar voor alle merken: BMW, Mercedes, Audi, Volkswagen, Ford, Opel en meer. Wij bedienen klanten uit heel de regio Antwerpen, inclusief Wommelgem, Mortsel, Kontich, Edegem, Schoten, Brasschaat, Wijnegem en omstreken. Onze installaties zijn volledig geïntegreerd met uw bestaande dashboard en stuurwielknoppen, zodat alles veilig en gebruiksvriendelijk blijft tijdens het rijden. CarPlay installeren Antwerpen was nog nooit zo eenvoudig - maak vandaag nog een afspraak.',
      benefits: [
        'Compatibel met iPhone en Android smartphones',
        'Draadloze CarPlay installatie Antwerpen voor alle merken',
        'Android Auto installeren in Antwerpen - professioneel en snel',
        'Volledige integratie met stuurwielknoppen',
        'Behoud van originele radio functionaliteit',
        'Garantie op materiaal en installatie in regio Antwerpen',
      ],
      useCases: [
        { title: 'Navigatie', desc: 'Google Maps, Waze en Apple Maps op groot scherm - ideaal voor Antwerpen verkeer' },
        { title: 'Muziek', desc: 'Spotify, Apple Music, YouTube Music en meer' },
        { title: 'Berichten', desc: 'WhatsApp, SMS en iMessage via spraakbediening' },
        { title: 'Bellen', desc: 'Handsfree bellen met kristalheldere geluidskwaliteit' },
      ],
      image: 'https://static.readdy.ai/image/9e62058216dff63d1a686833c97014ce/95842c940ae17c4b913fe5fce8e14e37.jpeg',
      features: [
        { icon: 'ri-wifi-line', title: 'Draadloos verbinden', desc: 'Geen kabels meer nodig' },
        { icon: 'ri-mic-line', title: 'Voice control', desc: 'Handsfree bediening' },
        { icon: 'ri-navigation-line', title: 'Navigatie', desc: 'Google Maps & Apple Maps' },
        { icon: 'ri-music-line', title: 'Muziek streaming', desc: 'Spotify, Apple Music, etc.' },
      ],
      color: 'from-cyan-400 to-blue-500',
      glowColor: 'cyan',
    },
    {
      id: 'android',
      icon: 'ri-tablet-line',
      title: 'Android Schermen',
      subtitle: 'Smart multimedia displays',
      description: 'Android scherm installeren Antwerpen - Upgrade naar een modern Android scherm met 4G connectiviteit. Stream Netflix, YouTube, Spotify en meer. Volledige Google Play toegang voor entertainment en navigatie tijdens het rijden.',
      longDescription: 'Transformeer uw auto-interieur met een groot Android multimedia scherm van DSF Cartech in Antwerpen. Android schermen installeren Antwerpen is onze specialiteit - deze moderne displays vervangen uw oude radio en bieden toegang tot alle populaire apps zoals Netflix, YouTube, Spotify en Google Maps. Dankzij de ingebouwde 4G connectiviteit bent u altijd online, zelfs zonder uw smartphone. De schermen zijn verkrijgbaar in verschillende formaten (van 9 tot 12.3 inch) en worden volledig geïntegreerd in uw dashboard voor een factory-look. Perfect voor lange ritten, wachten in de auto, of gewoon voor dagelijks entertainment. Wij installeren Android schermen in heel de regio Antwerpen: Wommelgem, Mortsel, Kontich, Edegem, Schoten, Brasschaat, Wijnegem, Deurne, Berchem en omstreken. Android display installatie Antwerpen voor alle automerken: BMW, Mercedes, Audi, Volkswagen, Ford, Opel, Toyota, Nissan en meer.',
      benefits: [
        'Groot touchscreen display (9-12.3 inch) - Android scherm Antwerpen',
        'Ingebouwde 4G/LTE voor internet zonder smartphone',
        'Volledige Google Play Store toegang - alle apps installeren',
        'Compatibel met CarPlay en Android Auto',
        'GPS navigatie met offline kaarten voor Antwerpen en België',
        'Bluetooth voor handsfree bellen en muziek',
      ],
      useCases: [
        { title: 'Entertainment', desc: 'Netflix, YouTube en streaming tijdens wachten - Android multimedia Antwerpen' },
        { title: 'Navigatie', desc: 'Google Maps met real-time verkeersinformatie voor Antwerpen' },
        { title: 'Muziek', desc: 'Spotify, YouTube Music en alle streaming diensten' },
        { title: 'Productiviteit', desc: 'E-mail, agenda en zakelijke apps' },
      ],
      image: 'https://static.readdy.ai/image/9e62058216dff63d1a686833c97014ce/b238ac32bd71f42da2bcafc90577c0c1.jpeg',
      features: [
        { icon: 'ri-netflix-line', title: 'Streaming apps', desc: 'Netflix, YouTube, etc.' },
        { icon: 'ri-signal-tower-line', title: '4G connectiviteit', desc: 'Altijd online' },
        { icon: 'ri-google-play-line', title: 'Google Play', desc: 'Alle apps beschikbaar' },
        { icon: 'ri-layout-line', title: 'Groot scherm', desc: 'Tesla-style display' },
      ],
      color: 'from-blue-400 to-indigo-500',
      glowColor: 'blue',
    },
  ];

  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "CarPlay & Android Schermen Installatie Antwerpen - DSF Cartech",
    "description": "Professionele CarPlay installatie en Android schermen installeren in Antwerpen. Draadloze CarPlay, Android Auto en multimedia upgrades voor alle automerken in regio Antwerpen.",
    "provider": {
      "@type": "LocalBusiness",
      "name": "DSF Cartech",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Ternesselei 191",
        "addressLocality": "Wommelgem",
        "addressRegion": "Antwerpen",
        "postalCode": "2160",
        "addressCountry": "BE"
      },
      "telephone": "+32489170592",
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "51.2194",
        "longitude": "4.4025"
      }
    },
    "areaServed": {
      "@type": "City",
      "name": "Antwerpen"
    },
    "serviceType": ["CarPlay installatie Antwerpen", "Android Auto installeren", "Android schermen installatie", "Smartphone integratie auto"]
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Waar kan ik CarPlay laten installeren in Antwerpen?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Bij DSF Cartech in Wommelgem (Antwerpen) kunt u terecht voor professionele CarPlay installatie. Wij bedienen de hele regio Antwerpen inclusief Mortsel, Kontich, Edegem, Schoten en Brasschaat."
        }
      },
      {
        "@type": "Question",
        "name": "Hoeveel kost Android scherm installeren in Antwerpen?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "De prijs voor Android schermen installatie in Antwerpen varieert afhankelijk van het schermformaat en uw automodel. Neem contact op voor een vrijblijvende offerte."
        }
      },
      {
        "@type": "Question",
        "name": "Welke automerken kunnen jullie upgraden met CarPlay?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Wij installeren CarPlay en Android Auto in vrijwel alle automerken: BMW, Mercedes, Audi, Volkswagen, Ford, Opel, Toyota, Nissan en meer. Neem contact op voor uw specifieke model."
        }
      }
    ]
  };

  return (
    <>
      <SEOHead
        title="CarPlay Installeren Antwerpen | Android Schermen Installatie | DSF Cartech"
        description="CarPlay installatie Antwerpen ✓ Android schermen installeren ✓ Draadloze CarPlay & Android Auto voor alle merken ✓ Professionele installatie in regio Antwerpen ✓ DSF Cartech Wommelgem"
        keywords="carplay installeren antwerpen, carplay installatie antwerpen, android schermen installeren antwerpen, android scherm installatie antwerpen, android auto installeren antwerpen, carplay antwerpen, android display auto antwerpen, smartphone integratie auto antwerpen, multimedia upgrade antwerpen, carplay wommelgem, android scherm wommelgem"
        canonical={`${siteUrl}/diensten/smartphone-multimedia`}
        schema={schema}
      />

      <div className="bg-black text-white min-h-screen">
        <Navigation />

        {/* Hero Section */}
        <section className="relative pt-24 md:pt-32 pb-12 md:pb-20 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-cyan-950/20 via-black to-black"></div>
          
          <div className="absolute inset-0 opacity-20">
            <div className="absolute top-20 left-1/4 w-96 h-96 bg-cyan-500/30 rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 right-1/4 w-96 h-96 bg-blue-500/30 rounded-full blur-3xl"></div>
          </div>

          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 relative z-10">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center"
            >
              <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="inline-block mb-4 md:mb-6"
              >
                <div className="px-4 md:px-6 py-2 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 border-2 border-cyan-400/50 rounded-full backdrop-blur-sm">
                  <span className="text-cyan-300 text-xs md:text-sm font-bold tracking-widest uppercase">Smartphone & Multimedia Antwerpen</span>
                </div>
              </motion.div>

              <h1 className="text-3xl md:text-5xl lg:text-7xl font-bold mb-4 md:mb-6 leading-tight px-4" style={{ fontFamily: 'Orbitron, monospace' }}>
                <span className="text-white">CarPlay Installeren</span>
                <br />
                <span className="bg-gradient-to-r from-cyan-300 via-blue-300 to-cyan-300 bg-clip-text text-transparent">
                  Antwerpen
                </span>
              </h1>

              <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-4 mb-6">
                <strong>CarPlay installatie Antwerpen</strong> en <strong>Android schermen installeren</strong> door DSF Cartech. Professionele smartphone integratie voor alle automerken in regio Antwerpen.
              </p>

              <p className="text-sm md:text-base text-gray-400 max-w-2xl mx-auto px-4">
                Wij bedienen: Wommelgem, Mortsel, Kontich, Edegem, Schoten, Brasschaat, Wijnegem, Deurne, Berchem en heel Antwerpen
              </p>
            </motion.div>
          </div>
        </section>

        {/* Services Navigation */}
        <section className="sticky top-16 md:top-20 z-40 bg-black/95 backdrop-blur-xl border-b border-white/10">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <div className="flex overflow-x-auto gap-2 py-3 md:py-4 scrollbar-hide">
              {services.map((service, index) => (
                <motion.button
                  key={service.id}
                  onClick={() => {
                    setActiveService(index);
                    document.getElementById(service.id)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className={`flex items-center gap-2 px-4 md:px-6 py-2 md:py-3 rounded-xl whitespace-nowrap transition-all duration-300 cursor-pointer ${
                    activeService === index
                      ? `bg-gradient-to-r ${service.color} text-white shadow-lg`
                      : 'bg-white/5 text-gray-400 hover:bg-white/10 hover:text-white'
                  }`}
                >
                  <i className={`${service.icon} text-base md:text-lg`}></i>
                  <span className="font-semibold text-xs md:text-sm">{service.title}</span>
                </motion.button>
              ))}
            </div>
          </div>
        </section>

        {/* Services Details */}
        <section className="py-12 md:py-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 space-y-20 md:space-y-32">
            {services.map((service, index) => (
              <motion.div
                key={service.id}
                id={service.id}
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true, margin: "-100px" }}
                className="relative"
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${service.color} opacity-5 blur-3xl rounded-3xl`}></div>

                <div className={`relative grid lg:grid-cols-2 gap-8 md:gap-12 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                  <motion.div
                    initial={{ opacity: 0, x: index % 2 === 0 ? -40 : 40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    viewport={{ once: true }}
                    className={`relative ${index % 2 === 1 ? 'lg:order-2' : ''}`}
                  >
                    <div className="relative group">
                      <div className={`absolute -inset-4 bg-gradient-to-br ${service.color} opacity-20 blur-2xl group-hover:opacity-30 transition-opacity duration-500 rounded-3xl`}></div>
                      <div className="relative overflow-hidden rounded-2xl border-2 border-white/10">
                        <img
                          src={service.image}
                          alt={service.title}
                          className="w-full h-64 md:h-96 object-cover transform group-hover:scale-105 transition-transform duration-700"
                        />
                      </div>
                    </div>
                  </motion.div>

                  <motion.div
                    initial={{ opacity: 0, x: index % 2 === 0 ? 40 : -40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, delay: 0.3 }}
                    viewport={{ once: true }}
                    className={index % 2 === 1 ? 'lg:order-1' : ''}
                  >
                    <div className="flex items-center gap-3 md:gap-4 mb-4 md:mb-6">
                      <div className={`w-12 h-12 md:w-16 md:h-16 flex items-center justify-center bg-gradient-to-br ${service.color} rounded-2xl shadow-2xl`}>
                        <i className={`${service.icon} text-2xl md:text-3xl text-white`}></i>
                      </div>
                      <div>
                        <h2 className="text-2xl md:text-4xl font-bold text-white" style={{ fontFamily: 'Orbitron, monospace' }}>
                          {service.title}
                        </h2>
                        <p className={`text-sm md:text-lg bg-gradient-to-r ${service.color} bg-clip-text text-transparent font-semibold`}>
                          {service.subtitle}
                        </p>
                      </div>
                    </div>

                    <p className="text-base md:text-lg text-gray-300 leading-relaxed mb-4 md:mb-6">
                      {service.description}
                    </p>

                    <p className="text-sm md:text-base text-gray-400 leading-relaxed mb-6 md:mb-8">
                      {service.longDescription}
                    </p>

                    <div className="grid grid-cols-2 gap-3 md:gap-4 mb-6 md:mb-8">
                      {service.features.map((feature, idx) => (
                        <motion.div
                          key={idx}
                          initial={{ opacity: 0, y: 20 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.5, delay: 0.4 + idx * 0.1 }}
                          viewport={{ once: true }}
                          className="p-3 md:p-4 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 hover:bg-white/10 transition-all duration-300"
                        >
                          <i className={`${feature.icon} text-xl md:text-2xl bg-gradient-to-r ${service.color} bg-clip-text text-transparent mb-2`}></i>
                          <h4 className="text-white font-semibold text-xs md:text-sm mb-1">{feature.title}</h4>
                          <p className="text-gray-400 text-xs">{feature.desc}</p>
                        </motion.div>
                      ))}
                    </div>

                    <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={() => window.REACT_APP_NAVIGATE('/contact')}
                      className={`w-full md:w-auto px-6 md:px-8 py-3 md:py-4 bg-gradient-to-r ${service.color} text-white font-bold rounded-xl whitespace-nowrap cursor-pointer shadow-2xl hover:shadow-3xl transition-all duration-300`}
                    >
                      <span className="flex items-center justify-center gap-2">
                        <i className="ri-calendar-check-line text-lg md:text-xl"></i>
                        <span className="text-sm md:text-base">Maak een Afspraak</span>
                      </span>
                    </motion.button>
                  </motion.div>
                </div>

                <motion.div
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.4 }}
                  viewport={{ once: true }}
                  className="mt-12 md:mt-16 grid md:grid-cols-2 gap-6 md:gap-8"
                >
                  <div className="p-6 md:p-8 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10">
                    <h3 className="text-xl md:text-2xl font-bold text-white mb-4 md:mb-6 flex items-center gap-3">
                      <i className="ri-checkbox-circle-line text-2xl md:text-3xl bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent"></i>
                      <span>Voordelen</span>
                    </h3>
                    <ul className="space-y-3 md:space-y-4">
                      {service.benefits.map((benefit, idx) => (
                        <motion.li
                          key={idx}
                          initial={{ opacity: 0, x: -20 }}
                          whileInView={{ opacity: 1, x: 0 }}
                          transition={{ duration: 0.5, delay: idx * 0.1 }}
                          viewport={{ once: true }}
                          className="flex items-start gap-3 text-gray-300"
                        >
                          <i className={`ri-check-line text-lg md:text-xl bg-gradient-to-r ${service.color} bg-clip-text text-transparent mt-1 flex-shrink-0`}></i>
                          <span className="text-xs md:text-sm leading-relaxed">{benefit}</span>
                        </motion.li>
                      ))}
                    </ul>
                  </div>

                  <div className="p-6 md:p-8 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10">
                    <h3 className="text-xl md:text-2xl font-bold text-white mb-4 md:mb-6 flex items-center gap-3">
                      <i className="ri-lightbulb-line text-2xl md:text-3xl bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent"></i>
                      <span>Toepassingen</span>
                    </h3>
                    <div className="space-y-3 md:space-y-4">
                      {service.useCases.map((useCase, idx) => (
                        <motion.div
                          key={idx}
                          initial={{ opacity: 0, x: 20 }}
                          whileInView={{ opacity: 1, x: 0 }}
                          transition={{ duration: 0.5, delay: idx * 0.1 }}
                          viewport={{ once: true }}
                          className="p-3 md:p-4 bg-white/5 rounded-xl border border-white/5 hover:bg-white/10 transition-all duration-300"
                        >
                          <h4 className={`text-white font-semibold text-xs md:text-sm mb-1 bg-gradient-to-r ${service.color} bg-clip-text text-transparent`}>
                            {useCase.title}
                          </h4>
                          <p className="text-gray-400 text-xs leading-relaxed">{useCase.desc}</p>
                        </motion.div>
                      ))}
                    </div>
                  </div>
                </motion.div>
              </motion.div>
            ))}
          </div>
        </section>

        {/* Local SEO Content Section */}
        <section className="py-12 md:py-20 bg-gradient-to-b from-black to-gray-900">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" style={{ fontFamily: 'Orbitron, monospace' }}>
                <strong>CarPlay Installeren Antwerpen</strong> - Uw Specialist
              </h2>
              <p className="text-base md:text-lg text-gray-300 max-w-4xl mx-auto leading-relaxed">
                DSF Cartech is dé specialist voor <strong>CarPlay installatie Antwerpen</strong> en <strong>Android schermen installeren</strong>. 
                Met jarenlange ervaring in auto-elektronica bedienen wij klanten in heel de regio Antwerpen.
              </p>
            </motion.div>

            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
                className="p-6 md:p-8 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10"
              >
                <h3 className="text-xl md:text-2xl font-bold text-white mb-4 flex items-center gap-3">
                  <i className="ri-map-pin-line text-2xl text-cyan-400"></i>
                  <span>Regio Antwerpen</span>
                </h3>
                <p className="text-gray-300 leading-relaxed mb-4">
                  <strong>CarPlay installeren Antwerpen</strong> en omstreken? Wij komen naar u toe of u komt langs in Wommelgem. 
                  Onze service is beschikbaar in:
                </p>
                <ul className="grid grid-cols-2 gap-2 text-sm text-gray-400">
                  <li className="flex items-center gap-2"><i className="ri-check-line text-cyan-400"></i> Wommelgem</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-cyan-400"></i> Mortsel</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-cyan-400"></i> Kontich</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-cyan-400"></i> Edegem</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-cyan-400"></i> Schoten</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-cyan-400"></i> Brasschaat</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-cyan-400"></i> Wijnegem</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-cyan-400"></i> Deurne</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-cyan-400"></i> Berchem</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-cyan-400"></i> Antwerpen</li>
                </ul>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
                className="p-6 md:p-8 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10"
              >
                <h3 className="text-xl md:text-2xl font-bold text-white mb-4 flex items-center gap-3">
                  <i className="ri-car-line text-2xl text-blue-400"></i>
                  <span>Alle Automerken</span>
                </h3>
                <p className="text-gray-300 leading-relaxed mb-4">
                  <strong>Android schermen installeren Antwerpen</strong> voor alle merken. Wij hebben ervaring met:
                </p>
                <ul className="grid grid-cols-2 gap-2 text-sm text-gray-400">
                  <li className="flex items-center gap-2"><i className="ri-check-line text-blue-400"></i> BMW</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-blue-400"></i> Mercedes</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-blue-400"></i> Audi</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-blue-400"></i> Volkswagen</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-blue-400"></i> Ford</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-blue-400"></i> Opel</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-blue-400"></i> Toyota</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-blue-400"></i> Nissan</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-blue-400"></i> Peugeot</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-blue-400"></i> En meer...</li>
                </ul>
              </motion.div>
            </div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="p-6 md:p-8 bg-gradient-to-r from-cyan-500/10 to-blue-500/10 backdrop-blur-sm rounded-2xl border border-cyan-400/30"
            >
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 text-center">
                Waarom Kiezen voor DSF Cartech?
              </h3>
              <div className="grid md:grid-cols-3 gap-6 mt-8">
                <div className="text-center">
                  <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-full flex items-center justify-center">
                    <i className="ri-shield-check-line text-3xl text-white"></i>
                  </div>
                  <h4 className="text-lg font-bold text-white mb-2">Garantie</h4>
                  <p className="text-sm text-gray-400">Volledige garantie op materiaal en installatie</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-full flex items-center justify-center">
                    <i className="ri-tools-line text-3xl text-white"></i>
                  </div>
                  <h4 className="text-lg font-bold text-white mb-2">Professioneel</h4>
                  <p className="text-sm text-gray-400">Jarenlange ervaring in auto-elektronica</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-full flex items-center justify-center">
                    <i className="ri-map-pin-2-line text-3xl text-white"></i>
                  </div>
                  <h4 className="text-lg font-bold text-white mb-2">Lokaal</h4>
                  <p className="text-sm text-gray-400">Gevestigd in Antwerpen, snel bereikbaar</p>
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-12 md:py-20 bg-black">
          <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: 'Orbitron, monospace' }}>
                Veelgestelde Vragen
              </h2>
              <p className="text-gray-400">Over CarPlay en Android schermen installatie in Antwerpen</p>
            </motion.div>

            <div className="space-y-4">
              {[
                {
                  q: "Waar kan ik CarPlay laten installeren in Antwerpen?",
                  a: "Bij DSF Cartech in Wommelgem (Antwerpen) kunt u terecht voor professionele CarPlay installatie. Wij bedienen de hele regio Antwerpen inclusief Mortsel, Kontich, Edegem, Schoten en Brasschaat."
                },
                {
                  q: "Hoeveel kost Android scherm installeren in Antwerpen?",
                  a: "De prijs voor Android schermen installatie in Antwerpen varieert afhankelijk van het schermformaat en uw automodel. Neem contact op voor een vrijblijvende offerte."
                },
                {
                  q: "Welke automerken kunnen jullie upgraden met CarPlay?",
                  a: "Wij installeren CarPlay en Android Auto in vrijwel alle automerken: BMW, Mercedes, Audi, Volkswagen, Ford, Opel, Toyota, Nissan en meer. Neem contact op voor uw specifieke model."
                },
                {
                  q: "Hoe lang duurt een CarPlay installatie?",
                  a: "Een standaard CarPlay installatie duurt gemiddeld 2-4 uur, afhankelijk van uw automodel. Android schermen installatie kan iets langer duren vanwege de complexiteit."
                },
                {
                  q: "Is draadloze CarPlay beter dan bedrade CarPlay?",
                  a: "Draadloze CarPlay biedt meer gemak omdat u geen kabel nodig heeft. Uw telefoon verbindt automatisch wanneer u instapt. Wij installeren beide opties in Antwerpen."
                }
              ].map((faq, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="p-6 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 hover:bg-white/10 transition-all duration-300"
                >
                  <h4 className="text-lg font-bold text-white mb-3 flex items-start gap-3">
                    <i className="ri-question-line text-cyan-400 text-xl mt-1 flex-shrink-0"></i>
                    <span>{faq.q}</span>
                  </h4>
                  <p className="text-gray-400 leading-relaxed pl-9">{faq.a}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-20 md:py-32 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-black via-cyan-950/20 to-black"></div>
          
          <div className="absolute inset-0 opacity-20">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-cyan-500/40 rounded-full blur-3xl"></div>
          </div>

          <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8 relative z-10 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6 text-white" style={{ fontFamily: 'Orbitron, monospace' }}>
                Klaar voor <span className="bg-gradient-to-r from-cyan-300 to-blue-300 bg-clip-text text-transparent">CarPlay Installatie?</span>
              </h2>
              <p className="text-base md:text-xl text-gray-300 mb-8 md:mb-12 leading-relaxed px-4">
                <strong>CarPlay installeren Antwerpen</strong> of <strong>Android schermen installatie</strong>? 
                Neem contact op voor een vrijblijvend adviesgesprek en ontdek wat wij voor uw auto kunnen betekenen.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 md:gap-6 justify-center px-4">
                <motion.button
                  whileHover={{ scale: 1.05, y: -2 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={() => window.REACT_APP_NAVIGATE('/contact')}
                  className="w-full sm:w-auto px-8 md:px-12 py-4 md:py-5 bg-gradient-to-r from-cyan-500 to-blue-500 text-black text-base md:text-lg font-bold rounded-2xl whitespace-nowrap cursor-pointer shadow-2xl shadow-cyan-500/50 hover:shadow-cyan-500/70 transition-all duration-300"
                >
                  <span className="flex items-center justify-center gap-3">
                    <i className="ri-calendar-check-line text-xl md:text-2xl"></i>
                    <span>Maak een Afspraak</span>
                  </span>
                </motion.button>

                <motion.a
                  href="tel:+32489170592"
                  whileHover={{ scale: 1.05, y: -2 }}
                  whileTap={{ scale: 0.98 }}
                  className="w-full sm:w-auto px-8 md:px-12 py-4 md:py-5 bg-white/10 backdrop-blur-xl border-2 border-white/30 text-white text-base md:text-lg font-bold rounded-2xl whitespace-nowrap cursor-pointer hover:bg-white/20 transition-all duration-300 shadow-lg hover:shadow-xl"
                >
                  <span className="flex items-center justify-center gap-3">
                    <i className="ri-phone-line text-xl md:text-2xl"></i>
                    <span>Bel Direct</span>
                  </span>
                </motion.a>
              </div>
            </motion.div>
          </div>
        </section>

        <Footer />
      </div>

      {/* Add FAQ Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </>
  );
}
